export default __webpack_public_path__ + "static/risk-reduction-a9bd01c2ddee921d7b2c81b99ab41dee.png";